export const SLEEK_THEMES = {
  CUSTOMER: "customer",
  ADMIN: "admin",
};

// TODO: Use color variants when doing night mode
// https://v15.vuetifyjs.com/en/framework/theme#custom-theme-variants
const THEMES = {
  [SLEEK_THEMES.CUSTOMER]: {
    primary: "#0066FF",
    secondary: "#1e81bf",
    accent: "#F69222",
    grey: "#9e9e9e",
    error: "#ff2122",
    info: "#1e81bf",
    success: "#03B5AA",
    warning: "#F69222",
  },
  [SLEEK_THEMES.ADMIN]: {
    primary: "#003AB6",
    secondary: "#1e81bf",
    accent: "#F69222",
    grey: "#9e9e9e",
    error: "#ff2122",
    info: "#1e81bf",
    success: "#03B5AA",
    warning: "#F69222",
  },
};

export const DEFAULT_THEME_NAME = "customer";
export const DEFAULT_THEME = THEMES[DEFAULT_THEME_NAME];

/**
 * Dynamically, on-the-fly set the theme of the app.
 * App will auto change all colors after this function executes.
 * @param {Vue} component the `this` instance of any Vue component that you are in
 * @param {String} themeName the name of the theme. See list of theme names in plugins/themes.js > SLEEK_THEME_NAMES
 * @returns void
 */
export const setTheme = (component, themeName = DEFAULT_THEME_NAME) => {
  const theme = THEMES[themeName];

  Object.keys(theme).forEach((themeProp) => {
    component.$vuetify.theme[themeProp] = theme[themeProp];
  });
};

export default DEFAULT_THEME;
